module.exports = __webpack_public_path__ + "img/cursos_talleres.332b08f6.jpg";